module.exports = __webpack_public_path__ + "static/aopsafaribathmain-3d19748c8f01aacba0fe4d272a90cdc2.jpeg";